module.exports = __webpack_public_path__ + "media/images/map-cf734d8a7bac310faa61f1d744d8e311.jpg";